export async function generateInvoice(order, lang = 'fr', type = 'facture') {
  if (!window.jspdf) {
    await new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = resolve;
      s.onerror = () => reject(new Error('Échec chargement jsPDF'));
      document.head.appendChild(s);
    });
  }
  await new Promise(r => setTimeout(r, 100));
  const { jsPDF } = window.jspdf;
  if (!jsPDF) throw new Error('jsPDF introuvable');

  const fr = lang === 'fr';
  const isDevis = type === 'devis';
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const W = 210, M = 15;
  let y = 0;

  const TVA_RATE = 0.20; // 20% TVA

  const C = {
    blue:    [11, 61, 110],
    teal:    [15, 110, 86],
    lgray:   [245, 247, 250],
    gray:    [100, 116, 139],
    black:   [26, 37, 53],
    white:   [255, 255, 255],
    amber:   [215, 119, 6],
    red:     [220, 38, 38],
    green:   [29, 158, 117],
    blueLight:[224, 237, 252],
  };

  const fill  = col => doc.setFillColor(...col);
  const color = col => doc.setTextColor(...col);
  const font  = (style, size) => { doc.setFont('helvetica', style); doc.setFontSize(size); };
  const safe  = v => String(v || '—');
  const clip  = (txt, maxPx) => {
    txt = safe(txt);
    while (doc.getTextWidth(txt) > maxPx && txt.length > 2) txt = txt.slice(0, -1);
    return txt;
  };
  const parsePrice = str => {
    const n = parseFloat(String(str || '0').replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  };
  const fmt = n => `${n.toFixed(2)} MAD`;

  const statusCols   = { pending: C.amber, confirmed: C.blue, delivered: C.green, cancelled: C.red, processing: [124,58,237] };
  const statusLabels = { pending: fr?'En attente':'Pending', confirmed: fr?'Confirmée':'Confirmed', delivered: fr?'Livrée':'Delivered', cancelled: fr?'Annulée':'Cancelled', processing: fr?'En cours':'Processing' };

  // ══════════════════════════════════════════════════════════════
  // HEADER
  // ══════════════════════════════════════════════════════════════
  fill(C.blue); doc.rect(0, 0, W, 44, 'F');

  // Logo cercle + croix
  doc.setDrawColor(...C.white); doc.setLineWidth(0.8);
  doc.circle(M + 6, 13, 6, 'S');
  fill(C.white); doc.rect(M+3, 11, 6, 2.5, 'F'); doc.rect(M+5, 9, 2.5, 6, 'F');
  fill(C.teal);  doc.rect(M+4.5, 11.5, 3, 1.5, 'F'); doc.rect(M+5.5, 9.5, 1.5, 3.5, 'F');

  color(C.white);
  font('bold', 16); doc.text('LOMED MEDICARE', M + 15, 12);
  font('normal', 8);
  doc.text(fr ? 'Distribution de dispositifs médicaux — Maroc' : 'Medical Device Distribution — Morocco', M + 15, 18);
  doc.text('contact@lomedmedicare.ma  |  +212 5XX XX XX XX', M + 15, 24);
  doc.text('Casablanca, Maroc', M + 15, 30);

  // Titre FACTURE / DEVIS
  font('bold', 24);
  doc.text(isDevis ? (fr?'DEVIS':'QUOTE') : (fr?'FACTURE':'INVOICE'), W - M, 16, { align: 'right' });
  font('normal', 8.5);
  doc.text(`N°  ${safe(order.orderNumber)}`, W - M, 24, { align: 'right' });
  doc.text(`${fr?'Date':'Date'} : ${new Date(order.createdAt || Date.now()).toLocaleDateString(fr?'fr-FR':'en-GB')}`, W - M, 30, { align: 'right' });

  // Badge statut
  const sc = statusCols[order.status] || C.gray;
  const sl = statusLabels[order.status] || safe(order.status);
  fill(sc); doc.roundedRect(W - M - 28, 34, 28, 7, 2, 2, 'F');
  color(C.white); font('bold', 7.5);
  doc.text(sl, W - M - 14, 38.5, { align: 'center' });

  y = 52;

  // ══════════════════════════════════════════════════════════════
  // INFO BLOCS
  // ══════════════════════════════════════════════════════════════
  const colW = (W - M * 2 - 6) / 2;
  const rx = M + colW + 6;

  fill(C.lgray); doc.roundedRect(M, y, colW, 48, 3, 3, 'F');
  color(C.blue); font('bold', 7);
  doc.text(fr?'ÉTABLISSEMENT CLIENT':'CLIENT INSTITUTION', M + 4, y + 5.5);
  color(C.black); font('bold', 9.5);
  doc.text(clip(order.institution, colW - 8), M + 4, y + 12);
  font('normal', 8);
  [[fr?'Type':'Type', order.institutionType],[fr?'Ville':'City', order.city],[fr?'Responsable':'Contact', order.contactName],[fr?'Téléphone':'Phone', order.phone],['Email', order.email]].forEach(([l,v],i)=>{
    color(C.gray); doc.text(l, M+4, y+18+i*5.6);
    color(C.black); doc.text(clip(safe(v), colW-28), M+24, y+18+i*5.6);
  });

  fill(C.lgray); doc.roundedRect(rx, y, colW, 48, 3, 3, 'F');
  color(C.blue); font('bold', 7);
  doc.text(isDevis?(fr?'DÉTAILS DEVIS':'QUOTE DETAILS'):(fr?'DÉTAILS COMMANDE':'ORDER DETAILS'), rx+4, y+5.5);
  font('normal', 8);
  [[fr?'N° document':'Doc No.', order.orderNumber],[fr?'Date':'Date', new Date(order.createdAt||Date.now()).toLocaleDateString(fr?'fr-FR':'en-GB')],[fr?'Livraison souhaitée':'Delivery', order.deliveryDate?new Date(order.deliveryDate).toLocaleDateString(fr?'fr-FR':'en-GB'):'—'],[fr?'Mode paiement':'Payment', order.paymentMethod],['Statut', sl]].forEach(([l,v],i)=>{
    color(C.gray); doc.text(l, rx+4, y+12+i*6.5);
    color(C.black); font(i===4?'bold':'normal',8); doc.text(clip(safe(v),colW-32), rx+34, y+12+i*6.5); font('normal',8);
  });

  y += 55;

  // ══════════════════════════════════════════════════════════════
  // TABLEAU PRODUITS
  // ══════════════════════════════════════════════════════════════
  const TW = W - M * 2;
  const COL = {
    ref:   { x: M+2,   w: 24, label: fr?'Référence':'Ref' },
    name:  { x: M+27,  w: 62, label: fr?'Désignation':'Product' },
    qty:   { x: M+91,  w: 12, label: fr?'Qté':'Qty',     center: true },
    unit:  { x: M+130, w: 0, label: fr?'Prix unit. HT':'Unit price', right: true },
    tva:   { x: M+133, w: 16, label: 'TVA %',            center: true },
    total: { x: M+TW,  w: 0,  label: fr?'Montant TTC':'Amount',       right: true },
  };

  fill(C.blue); doc.rect(M, y, TW, 8, 'F');
  color(C.white); font('bold', 7.5);
  Object.values(COL).forEach(c => {
    const tx = c.right ? c.x : c.center ? c.x + c.w/2 : c.x;
    doc.text(c.label, tx, y+5.5, { align: c.right?'right':c.center?'center':'left' });
  });
  y += 8;

  // Données produits
  const rows = [];
  if (order.items?.length > 0) {
    order.items.forEach(it => rows.push({
      ref: it.productRef||'—', name: it.productName||'—',
      qty: it.quantity||1, price: parsePrice(it.unitPrice)
    }));
  }
  if (order.freeText) {
    order.freeText.split('\n').filter(l=>l.trim()).forEach(line => {
      rows.push({ ref:'—', name:line.trim(), qty:1, price:0 });
    });
  }
  if (rows.length===0) rows.push({ ref:'—', name:fr?'Voir remarques':'See notes', qty:1, price:0 });

  let totalHT = 0;
  rows.forEach((row, i) => {
    const rh = 8;
    if (i%2===0) { fill(C.lgray); doc.rect(M, y, TW, rh, 'F'); }
    const lineHT = row.price * row.qty;
    totalHT += lineHT;
    const lineTTC = lineHT * (1 + TVA_RATE);
    color(C.black); font('normal', 7.5);
    doc.text(clip(row.ref,  COL.ref.w-1),  COL.ref.x,  y+5.5);
    doc.text(clip(row.name, COL.name.w-2), COL.name.x, y+5.5);
    doc.text(String(row.qty), COL.qty.x+COL.qty.w/2, y+5.5, {align:'center'});
    doc.text(row.price>0?fmt(row.price):'Sur devis', COL.unit.x+COL.unit.w, y+5.5, {align:'right'});
    doc.text('20%', COL.tva.x+COL.tva.w/2, y+5.5, {align:'center'});
    doc.text(row.price>0?fmt(lineTTC):'Sur devis', COL.total.x, y+5.5, {align:'right'});
    y += rh;
  });

  // Séparateur
  doc.setDrawColor(...C.blue); doc.setLineWidth(0.3);
  doc.line(M, y, M+TW, y);
  y += 5;

  // ══════════════════════════════════════════════════════════════
  // TOTAUX
  // ══════════════════════════════════════════════════════════════
  const totalTVA = totalHT * TVA_RATE;
  const totalTTC = totalHT * (1 + TVA_RATE);
  const hasPrices = totalHT > 0;

  const totBox = [
    [fr?'Total HT':'Subtotal (excl. VAT)', hasPrices?fmt(totalHT):(fr?'Sur devis':'On quote')],
    [`TVA (20%)`,                           hasPrices?fmt(totalTVA):(fr?'Sur devis':'On quote')],
    [fr?'TOTAL TTC':'TOTAL (incl. VAT)',    hasPrices?fmt(totalTTC):(fr?'Sur devis':'On quote'), true],
  ];

  const boxW = 90;
  const boxX = M + TW - boxW;
  let ty = y;
  fill(C.lgray); doc.roundedRect(boxX, ty, boxW, 34, 3, 3, 'F');

  totBox.forEach(([l, v, bold], i) => {
    if (bold) {
      fill(C.blue); doc.rect(boxX, ty+22, boxW, 12, 'F');
      color(C.white); font('bold', 9);
      doc.text(l, boxX+4, ty+30);
      doc.text(v, boxX+boxW-4, ty+30, {align:'right'});
    } else {
      color(C.gray); font('normal', 8);
      doc.text(l, boxX+4, ty+6+i*8);
      color(C.black); font('normal', 8);
      doc.text(v, boxX+boxW-4, ty+6+i*8, {align:'right'});
    }
  });
  y = ty + 40;

  // ── Remarques ──
  if (order.notes?.trim()) {
    fill(C.lgray); doc.roundedRect(M, y, TW-boxW-4, 20, 3, 3, 'F');
    color(C.gray); font('bold', 7);
    doc.text(fr?'REMARQUES':'NOTES', M+4, y+5.5);
    color(C.black); font('normal', 7.5);
    const lines = doc.splitTextToSize(order.notes, TW-boxW-12);
    doc.text(lines.slice(0,2), M+4, y+11);
  }

  // ══════════════════════════════════════════════════════════════
  // FOOTER
  // ══════════════════════════════════════════════════════════════
  fill(C.blue); doc.rect(0, 280, W, 17, 'F');
  color(C.white); font('normal', 7.5);
  doc.text('LOMED MEDICARE  —  Casablanca, Maroc  —  contact@lomedmedicare.ma  —  +212 5XX XX XX XX', W/2, 286, {align:'center'});
  font('normal', 6.5);
  doc.text(
    fr?'Ce document est une confirmation de commande. Devis valable 30 jours. Soumis aux conditions générales de vente LOMED MEDICARE.'
      :'This document is an order confirmation. Quote valid for 30 days. Subject to LOMED MEDICARE general terms.',
    W/2, 292, {align:'center'}
  );

  const label = isDevis ? 'Devis' : 'Facture';
  doc.save(`${safe(order.orderNumber)}_${label}_LOMED_MEDICARE.pdf`);
}
